import { GridCol, GridRow, mixins, styled } from '@bob/library'

export const LinksWrapper = styled(GridRow)`
  margin-top: 50px;
  ${mixins.media.min.desktop} {
    margin-top: 100px;
  }
  margin-bottom: 70px;
  @media print {
    display: none;
  }
`

export interface ContentWrapperProps {
  mobileShow: boolean
}

export const SideWrapper = styled(GridCol)`
  padding: 0;
  ${mixins.media.max.desktop} {
    &:not(:first-child) {
      margin-top: 50px;
    }
    & > h2 {
      display: none;
    }
  }
  ${mixins.media.min.desktop} {
    & > button {
      display: none;
    }
  }
`

export const LargeTitle = styled.div`
  ${mixins.typography.headlineMedium}
  font-weight: 400;
`

export const CategoryTitle = styled.div`
  ${mixins.typography.headlineSmall}
  ${mixins.margin.bottom(15)}
`

export const LargeMobileButton = styled.button`
  padding: 10px 10px 10px 0px !important;
  ${mixins.cta.tertiary('black')}
  & > span {
    ${mixins.typography.noColor.headlineMedium}
    font-weight: 400;
    text-transform: none;
  }
`

export const ContentWrapper = styled.section<ContentWrapperProps>`
  display: flex;
  ${mixins.media.max.desktop} {
    display: ${({ mobileShow }) => (mobileShow ? 'flex' : 'none')};
  }

  flex-wrap: wrap;
  margin-top: 50px;
`

export const SectionWrapper = styled.nav`
  display: flex;
  flex-direction: column;
  width: 33.33%;
  ${mixins.media.max.desktop} {
    ${mixins.padding(0, 10, 20)}
    width: 50%;
  }
  & > a {
    ${mixins.typography.paragraphMedium}
  }

  ${mixins.padding(0, 5)}
`

export const LinkList = styled.ul`
  ${mixins.padding(0)}
  ${mixins.margin(0)}
`

export const LinkListItem = styled.li`
  list-style: none;
  ${mixins.padding(0)}
`

export const Link = styled.a`
  ${mixins.cta.hyperlink('black')}
  & {
    ${mixins.padding(5, 0)}
  }
`
